import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { usersDTO } from '../entidades/entidades.component';


@Injectable({
  providedIn: 'root'
})
export class PerfilesUsuarioService {
  token: string;
  httpOptions;
  httpOptionsABM;
  constructor(private http: HttpClient) {
    this.cargarToken();
  }
  URL_InspeccionTotal = `${environment.URL_InspeccionTotal}`;


  //#region  roles
  ROLE_ADMIN: boolean = false;
  RECEPTOR: boolean = false;
  CEDENTE: boolean = false;
  ADMINOPERADOR: boolean = false;
  LOGIN: boolean = false;
  INSPECCION_AVERIA: boolean = false;
  CONSULTAR_AVERIAS_PREVIAS: boolean = false;
  CONFIRMAR_ENTREGA: boolean = false;
  GESTIONAR_USUARIOS: boolean = false;
  GESTIONAR_PERFILES: boolean = false;
  CONSULTAR_AVERIAS: boolean = false;
  EDITAR_AVERIAS: boolean = false;
  GESTIONAR_REPORTES_PRELOAD: boolean = false;
  GESTIONAR_REPORTES_DESCARGA: boolean = false;
  GESTIONAR_REPORTES_AVERIAS_X_FECHA: boolean = false;
  GESTIONAR_REPORTES_AVERIAS_X_FECHA_INTEGRAL: boolean = false;
  GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD: boolean = false;
  GESTIONAR_REPORTES_PROFORMA: boolean = false;
  METRICAS: boolean = false;
  GESTIONAR_DISCREPANCIAS: boolean = false;
  GESTIONAR_PARAMETROS_SISTEMA: boolean = false;
  GESTIONAR_REPARACIONES_DEBITOS = false;
  GESTIONAR_REPARACIONES_SEGUROS = false;
  CONSULTAR_PARAMETROS_SISTEMA = false;
  GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA_PROCESO: boolean = false;
  GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA_PROCESO: boolean = false;

  GESTIONAR_REPORTES_INSPECCION_ENTREGA_FECHA_PROCESO: boolean = false;
  GESTIONAR_REPORTES_INSPECCION_RECEPCION_FECHA_PROCESO: boolean = false;

  GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA: boolean = false;
  GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA: boolean = false;
  ELIMINAR_AVERIAS: boolean = false;

  // v1.0.8
  GESTIONAR_REPORTES_TRAZABILIDAD_POR_PROCESO: boolean = false;
  GESTIONAR_REPORTES_TRAZABILIDAD_RECEPCION: boolean = false;
  GESTIONAR_REPORTES_TRAZABILIDAD_ENTREGA: boolean = false;
  GESTIONAR_REPORTES_DANIOS_SIN_CONFIRMAR: boolean = false;
  GESTIONAR_REPORTES_DANIOS_ASIGNADOS: boolean = false;
  GESTIONAR_REPORTES_DANIOS_RECHAZADOS: boolean = false;

  // v1.0.9
  GESTIONAR_BUQUES: boolean = false;
  CONSULTAR_BUQUES: boolean = false;
  GESTIONAR_MODELOS: boolean = false;
  CONSULTAR_MODELOS: boolean = false;
  GESTIONAR_CRITERIOS_SIMILITUD: boolean = false;
  GESTIONAR_OPERADORES: boolean = false;
  CONSULTAR_OPERADORES: boolean = false;
  CONSULTA_USUARIO_OPERADOR: boolean = false;
  EDITAR_AVERIAS_DISCREPANCIA: boolean = false;

  //v1.1.0
  ALTA_VISITA: boolean = false;
  MODIFICAR_VISITA: boolean = false;
  ELIMINAR_VISITA: boolean = false;
  CONSULTAR_VISITA: boolean = false;

  //1.4.0
  REPORTES_BI: boolean = false;
  GESTIONAR_ARCHIVOS_USUARIOS: boolean = false;
  CONSULTAR_ARCHIVOS_USUARIOS: boolean = false;
  REPORTES_INTERNOS: boolean = false
  OPERADORES_A_CLIENTES: boolean = false
  //#endregion

  //#region Perfiles Usuarios
  getPerfilUsuario() {
    this.cargarToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/users', this.httpOptions)
  }
  getUsuarios(filterDTO): Observable<any> {
    this.cargarToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/users/BuscarUsuarios', filterDTO, this.httpOptionsABM)
      .pipe(
        catchError(this.handleErrorInf)
      );
  }
  getUsuariosOperador(filterDTO): Observable<any> {
    this.cargarToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/users/BuscarPorOperador', filterDTO, this.httpOptionsABM)
      .pipe(
        catchError(this.handleErrorInf)
      );
  }
  getPerfilUsuarioPorId(idPerfilUsuario: number) {
    this.cargarToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/users/' + idPerfilUsuario, this.httpOptions)
  }
  postPerfilUsuario(guardarPerfilUsuario) {
    this.cargarToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/users', guardarPerfilUsuario, this.httpOptionsABM)
      .pipe(
        catchError(this.handleErrorInf)
      );
  }
  deletePerfilUsuario(idPerfilUsuario: number) {
    this.cargarToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/users/' + idPerfilUsuario, this.httpOptionsABM)
  }
  putPerfilUsuario(idPerfilUsuario: number, perfilUsuario: any) {
    this.cargarToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/users/' + idPerfilUsuario, perfilUsuario, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }
  getPerfiles(): Observable<any> {
    this.cargarToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/perfiles?page=0&size=9999&sort=id', this.httpOptions)
  }
  changePassword(userPwDTO) {
    this.cargarToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/users/ResetearPassword', userPwDTO, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  //#endregion
  removePermisos() {
    this.ROLE_ADMIN = false;
    this.RECEPTOR = false;
    this.CEDENTE = false;
    this.ADMINOPERADOR = false;
    this.LOGIN = false;
    this.INSPECCION_AVERIA = false;
    this.CONSULTAR_AVERIAS_PREVIAS = false;
    this.CONFIRMAR_ENTREGA = false;
    this.GESTIONAR_USUARIOS = false;
    this.GESTIONAR_PERFILES = false;
    this.CONSULTAR_AVERIAS = false;
    this.EDITAR_AVERIAS = false;
    this.GESTIONAR_REPORTES_PRELOAD = false;
    this.GESTIONAR_REPORTES_DESCARGA = false;
    this.GESTIONAR_REPORTES_AVERIAS_X_FECHA = false;
    this.GESTIONAR_REPORTES_AVERIAS_X_FECHA_INTEGRAL = false;
    this.GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD = false;
    this.GESTIONAR_REPORTES_PROFORMA = false;
    this.METRICAS = false;
    this.GESTIONAR_DISCREPANCIAS = false;
    this.GESTIONAR_PARAMETROS_SISTEMA = false;
    this.GESTIONAR_REPARACIONES_DEBITOS = false;
    this.GESTIONAR_REPARACIONES_SEGUROS = false;
    this.CONSULTAR_PARAMETROS_SISTEMA = false;
    this.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA_PROCESO = false;
    this.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA_PROCESO = false;
    this.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA = false;
    this.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA = false;
    this.GESTIONAR_REPORTES_INSPECCION_RECEPCION_FECHA_PROCESO = false;
    this.GESTIONAR_REPORTES_INSPECCION_ENTREGA_FECHA_PROCESO = false;
    this.ELIMINAR_AVERIAS = false
    //v.1.0.8
    this.GESTIONAR_REPORTES_DANIOS_SIN_CONFIRMAR = false;
    this.GESTIONAR_REPORTES_DANIOS_ASIGNADOS = false;
    this.GESTIONAR_REPORTES_DANIOS_RECHAZADOS = false;
    this.GESTIONAR_REPORTES_TRAZABILIDAD_POR_PROCESO = false;
    this.GESTIONAR_REPORTES_TRAZABILIDAD_ENTREGA = false;
    this.GESTIONAR_REPORTES_TRAZABILIDAD_RECEPCION = false;
    //v.1.0.9
    this.GESTIONAR_BUQUES = false;
    this.CONSULTAR_BUQUES = false;
    this.GESTIONAR_MODELOS = false;
    this.CONSULTAR_MODELOS = false;
    this.GESTIONAR_CRITERIOS_SIMILITUD = false;
    this.GESTIONAR_OPERADORES = false;
    this.CONSULTAR_OPERADORES = false;
    this.CONSULTA_USUARIO_OPERADOR = false;
    this.EDITAR_AVERIAS_DISCREPANCIA = false;
    //v.1.1.0
    this.ALTA_VISITA = false;
    this.MODIFICAR_VISITA = false;
    this.ELIMINAR_VISITA = false;
    this.CONSULTAR_VISITA = false;

    this.REPORTES_BI = false;
    this.GESTIONAR_ARCHIVOS_USUARIOS = false;
    this.CONSULTAR_ARCHIVOS_USUARIOS = false;
    this.REPORTES_INTERNOS = false
    this.OPERADORES_A_CLIENTES = false
  }

  //#region Permisos por roles
  verificarRoles(datosUsuario: usersDTO) {
    this.removePermisos();
    var perfiles = datosUsuario.perfil.perfilRoles;
    var roles: [{ descripcion: string }] = [{ descripcion: "0" }];
    perfiles.forEach(element => {
      roles.push({ descripcion: element.rol.descripcion });
    });
    //ROLE_ADMIN
    if (roles.find(n => n.descripcion == "ROLE_ADMIN")) {
      this.ROLE_ADMIN = true;
    }
    // RECEPTOR
    if (roles.find(n => n.descripcion == "RECEPTOR")) {
      this.RECEPTOR = true;
    }
    // CEDENTE
    if (roles.find(n => n.descripcion == "CEDENTE")) {
      this.CEDENTE = true;
    }
    // ADMINOPERADOR
    if (roles.find(n => n.descripcion == "ADMINOPERADOR")) {
      this.ADMINOPERADOR = true;
    }
    // LOGIN
    if (roles.find(n => n.descripcion == "LOGIN")) {
      this.LOGIN = true;
    }
    // INSPECCION+AVERIA
    if (roles.find(n => n.descripcion == "INSPECCION_AVERIA")) {
      this.INSPECCION_AVERIA = true;
    }
    // CONSULTAR_AVERIAS_PREVIAS
    if (roles.find(n => n.descripcion == "CONSULTAR_AVERIAS_PREVIAS")) {
      this.CONSULTAR_AVERIAS_PREVIAS = true;
    }
    // CONFIRMAR_ENTREGA
    if (roles.find(n => n.descripcion == "CONFIRMAR_ENTREGA")) {
      this.CONFIRMAR_ENTREGA = true;
    }
    // GESTIONAR_USUARIOS
    if (roles.find(n => n.descripcion == "GESTIONAR_USUARIOS")) {
      this.GESTIONAR_USUARIOS = true;
    }
    // GESTIONAR_PERFILES
    if (roles.find(n => n.descripcion == "GESTIONAR_PERFILES")) {
      this.GESTIONAR_PERFILES = true;
    }
    // CONSULTAR_AVERIAS
    if (roles.find(n => n.descripcion == "CONSULTAR_AVERIAS")) {
      this.CONSULTAR_AVERIAS = true;
    }
    // EDITAR_AVERIAS
    if (roles.find(n => n.descripcion == "EDITAR_AVERIAS")) {
      this.EDITAR_AVERIAS = true;
    }
    // GESTIONAR_REPORTES_PRELOAD
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_PRELOAD")) {
      this.GESTIONAR_REPORTES_PRELOAD = true;
    }
    // GESTIONAR_REPORTES_DESCARGA
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_DESCARGA")) {
      this.GESTIONAR_REPORTES_DESCARGA = true;
    }
    // GESTIONAR_REPORTES_AVERIAS_X_FECHA
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_AVERIAS_X_FECHA")) {
      this.GESTIONAR_REPORTES_AVERIAS_X_FECHA = true;
    }
    // GESTIONAR_REPORTES_AVERIAS_X_FECHA_INTEGRAL
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_AVERIAS_X_FECHA_INTEGRAL")) {
      this.GESTIONAR_REPORTES_AVERIAS_X_FECHA_INTEGRAL = true;
    }
    // GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD")) {
      this.GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD = true;
    }
    // GESTIONAR_REPORTES_PROFORMA
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_PROFORMA")) {
      this.GESTIONAR_REPORTES_PROFORMA = true;
    }
    // METRICAS
    if (roles.find(n => n.descripcion == "METRICAS")) {
      this.METRICAS = true;
    }
    // GESTIONAR_DISCREPANCIAS
    if (roles.find(n => n.descripcion == "GESTIONAR_DISCREPANCIAS")) {
      this.GESTIONAR_DISCREPANCIAS = true;
    }
    // GESTIONAR_PARAMETROS_SISTEMA
    if (roles.find(n => n.descripcion == "GESTIONAR_PARAMETROS_SISTEMA")) {
      this.GESTIONAR_PARAMETROS_SISTEMA = true;
    }
    // REPARACIONES
    if (roles.find(n => n.descripcion == "GESTIONAR_REPARACIONES_DEBITOS")) {
      this.GESTIONAR_REPARACIONES_DEBITOS = true;
    }
    if (roles.find(n => n.descripcion == "GESTIONAR_REPARACIONES_SEGUROS")) {
      this.GESTIONAR_REPARACIONES_SEGUROS = true;
    }
    // CONSULTAR_PARAMETROS_SISTEMA
    if (roles.find(n => n.descripcion == "CONSULTAR_PARAMETROS_SISTEMA")) {
      this.CONSULTAR_PARAMETROS_SISTEMA = true;
    }
    // GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA_PROCESO
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA_PROCESO")) {
      this.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA_PROCESO = true;
    }
    // GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA_PROCESO
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA_PROCESO")) {
      this.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA_PROCESO = true;
    }

    //AGREGAMOS PERMISOS A LOS 2 NUEVOS REPORTES 15/04/2021
    // GESTIONAR_REPORTES_INSPECCION_ENTREGA_FECHA_PROCESO
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_INSPECCION_ENTREGA_FECHA_PROCESO")) {
      this.GESTIONAR_REPORTES_INSPECCION_ENTREGA_FECHA_PROCESO = true;
    }

    // GESTIONAR_REPORTES_INSPECCION_RECEPCION_FECHA_PROCE
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_INSPECCION_RECEPCION_FECHA_PROCESO")) {
      this.GESTIONAR_REPORTES_INSPECCION_RECEPCION_FECHA_PROCESO = true;
    }

    // AGREGAMOS PERMISOS A LOS 2 NUEVOS REPORTES 06/05/2021
    // GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA")) {
      this.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA = true;
    }

    // GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA")) {
      this.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA = true;
    }
    // ELIMINAR_AVERIAS
    if (roles.find(n => n.descripcion == "ELIMINAR_AVERIAS")) {
      this.ELIMINAR_AVERIAS = true;
    }
    // TRAZABILIDAD POR PROCESO
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_TRAZABILIDAD_POR_PROCESO")) {
      this.GESTIONAR_REPORTES_TRAZABILIDAD_POR_PROCESO = true;
    }
    // TRAZABILIDAD RECEPCION
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_TRAZABILIDAD_RECEPCION")) {
      this.GESTIONAR_REPORTES_TRAZABILIDAD_RECEPCION = true;
    }
    // TRAZABILIDAD ENTREGA
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_TRAZABILIDAD_ENTREGA")) {
      this.GESTIONAR_REPORTES_TRAZABILIDAD_ENTREGA = true;
    }
    // DAÑOS SIN CONFIRMAR
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_DANIOS_SIN_CONFIRMAR")) {
      this.GESTIONAR_REPORTES_DANIOS_SIN_CONFIRMAR = true;
    }
    // DAÑOS ASIGNADOS
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_DANIOS_ASIGNADOS")) {
      this.GESTIONAR_REPORTES_DANIOS_ASIGNADOS = true;
    }
    // DAÑOS RECHAZADOS
    if (roles.find(n => n.descripcion == "GESTIONAR_REPORTES_DANIOS_RECHAZADOS")) {
      this.GESTIONAR_REPORTES_DANIOS_RECHAZADOS = true;
    }
    if (roles.find(n => n.descripcion == "GESTIONAR_BUQUES")) {
      this.GESTIONAR_BUQUES = true;
    }
    if (roles.find(n => n.descripcion == "CONSULTAR_BUQUES")) {
      this.CONSULTAR_BUQUES = true;
    }
    if (roles.find(n => n.descripcion == "GESTIONAR_MODELOS")) {
      this.GESTIONAR_MODELOS = true;
    }
    if (roles.find(n => n.descripcion == "CONSULTAR_MODELOS")) {
      this.CONSULTAR_MODELOS = true;
    }
    if (roles.find(n => n.descripcion == "GESTIONAR_CRITERIOS_SIMILITUD")) {
      this.GESTIONAR_CRITERIOS_SIMILITUD = true;
    }
    if (roles.find(n => n.descripcion == "GESTIONAR_OPERADORES")) {
      this.GESTIONAR_OPERADORES = true;
    }
    if (roles.find(n => n.descripcion == "CONSULTAR_OPERADORES")) {
      this.CONSULTAR_OPERADORES = true;
    }
    if (roles.find(n => n.descripcion == "CONSULTA_USUARIO_OPERADOR")) {
      this.CONSULTA_USUARIO_OPERADOR = true;
    }
    if (roles.find(n => n.descripcion == "EDITAR_AVERIAS_DISCREPANCIA")) {
      this.EDITAR_AVERIAS_DISCREPANCIA = true;
    }
    if (roles.find(n => n.descripcion == "ALTA_VISITA")) {
      this.ALTA_VISITA = true;
    }
    if (roles.find(n => n.descripcion == "MODIFICAR_VISITA")) {
      this.MODIFICAR_VISITA = true;
    }
    if (roles.find(n => n.descripcion == "ELIMINAR_VISITA")) {
      this.ELIMINAR_VISITA = true;
    }
    if (roles.find(n => n.descripcion == "CONSULTAR_VISITA")) {
      this.CONSULTAR_VISITA = true;
    }
    if (roles.find(n => n.descripcion == "REPORTES_BI")) {
      this.REPORTES_BI = true;
    }
    if (roles.find(n => n.descripcion == "CONSULTAR_ARCHIVOS_USUARIOS")) {
      this.CONSULTAR_ARCHIVOS_USUARIOS = true;
    }
    if (roles.find(n => n.descripcion == "GESTIONAR_ARCHIVOS_USUARIOS")) {
      this.GESTIONAR_ARCHIVOS_USUARIOS = true;
    }
    if (roles.find(n => n.descripcion == "REPORTES_INTERNOS")) {
      this.REPORTES_INTERNOS = true;
    }
    if (roles.find(n => n.descripcion == "OPERADORES_A_CLIENTES")) {
      this.OPERADORES_A_CLIENTES = true;
    }
    return this.LOGIN;
  }
  //#endregion

  handleError(error) {
    let errorMessage = '';
    window.alert(error.error);
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(errorMessage);
  }

  handleErrorInf(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.errors[0].message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  };

  cargarToken() {
    this.token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8', 'Authorization': 'Bearer ' + this.token
      })
    };
    this.httpOptionsABM = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8', 'Authorization': 'Bearer ' + this.token
      }),
      observe: 'response'
    };
  }
}
